<!-- Billing Top App Bar -->
<app-base-top-app-bar
  [user$]="user$"
  [userRoleLabel]="'Billing Account'"
  [hideAdminConsoleLink]="false"
  (signOut)="onSignOut()"
  (switchAccount)="onSwitchAccount()"
  class="billing-theme"
>
  <!-- Return to projects navigation button -->
  <div slot="left-actions" class="billing-left-actions">
    <a
      mat-button
      routerLink="/"
      class="back-to-projects-button"
      data-testid="billing-back-to-projects"
      aria-label="Back to projects"
      matTooltip="Back to projects"
    >
      <mat-icon>arrow_back</mat-icon>
      <span class="back-button-label">Projects</span>
    </a>
  </div>

  <!-- Billing-specific content -->
  <span slot="content" class="billing-title" data-testid="billing-title">Billing & Account</span>

  <!-- Billing-specific actions -->
  <div slot="actions" class="billing-actions">
    <button
      data-testid="billing-refresh"
      mat-icon-button
      matTooltip="Refresh billing data"
      aria-label="Refresh billing data"
      (click)="onRefresh()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</app-base-top-app-bar>
